/**
 * Resolves a business ID from an object that may be a hydrated Mongoose document
 * (with a virtual `id` field) or a lean/plain object (with only `_id`).
 *
 * Use this everywhere you need a business ID from `account.business` to avoid
 * silent undefined comparisons when the server returns lean documents.
 */
export function resolveBusinessId(
    business: { id?: string; _id?: string | { toString(): string } } | null | undefined
): string | undefined {
    if (!business) return undefined
    return business.id || (business._id as any)?.toString?.() || (business._id as any)
}

/**
 * Finds the active business account from a list, safely handling both
 * hydrated and lean Mongoose documents.
 */
export function findActiveBusinessAccount<T extends { business: { id?: string; _id?: any } }>(
    accounts: T[] | undefined | null,
    activeBusiness: string | undefined | null
): T | undefined {
    if (!accounts || !activeBusiness) return undefined
    return accounts.find(account => resolveBusinessId(account.business) === activeBusiness)
}
